/**
 * Internal data providers that can be used for company lookups
 * These mirror the backend InternalProviderEnum
 */
export enum InternalProvider {
  Aumni = 'Aumni',
  DiligentEquity = 'DiligentEquity',
  ILevel = 'ILevel',
  Investran = 'Investran',
  Carta = 'Carta',
  StandardMetrics = 'StandardMetrics',
  Cobalt = 'Cobalt',
}

/**
 * Array of all internal provider values for use in dropdowns
 */
export const INTERNAL_PROVIDERS = Object.values(InternalProvider);
